import { render, staticRenderFns } from "./DropdownNavigationBar.vue?vue&type=template&id=bef5feca"
import script from "./DropdownNavigationBar.vue?vue&type=script&lang=js"
export * from "./DropdownNavigationBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports